// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rPWJ","largestCol":"styles_largestCol__1mZ4G","smallestCol":"styles_smallestCol__viccC"};